import * as React from 'react';

import Button from '../Button/Button';
import Icon from '../Icon/Icon';

interface Props {
  children: any;
  link?: string;
  className?: string;
  icon: string;
  large?: boolean;
  isRight?: boolean;
  handleClick?: any;
}

export default class IconButton extends React.Component<Props> {
  static defaultProps = {
    className: 'is-primary',
    large: false,
    isRight: false,
    handleClick: () => {},
  };

  render() {
    return (
      <Button
        link={this.props.link}
        className={`${this.props.className}${
          this.props.large ? ' is-large' : ''
        }`}
        handleClick={this.props.handleClick}
      >
        <div className="level">
          <div className="level-left">
            {!this.props.isRight && (
              <Icon
                icon={this.props.icon}
                size={this.props.large ? 'medium' : 'small'}
              />
            )}
            <span>{this.props.children}</span>
            {this.props.isRight && (
              <Icon
                icon={this.props.icon}
                size={this.props.large ? 'medium' : 'small'}
              />
            )}
          </div>
        </div>
      </Button>
    );
  }
}
